module.exports = __webpack_public_path__ + "img/OHM_120X35.e58ed3e7.png";